// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af3d10b0","749":"1c49334e","903":"b3a822f5"}[chunkId] + ".chunk.js";
};